import { cardContainerMultiColumnStyles } from "@insite/content-library/Components/CardContainerMultiColumn";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { PRODUCT_LIST } from "@store/theme/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(cardContainerMultiColumnStyles, {
    gridItem: {
        width: [12, 6, 6, 4, 4],
        css: css`
            border-left: 1px solid transparent;
        `,
    },
    cardDivider: {
        css: css`
            position: relative;
            width: 100%;
            height: 100%;
            &::before {
                content: "";
                display: block;
                position: absolute;
                left: 0;
                width: 1px;
                height: 100%;
                background-color: ${getColor("common.border")};

                ${props =>
                    breakpointValuesMediaQueries(
                        props.theme,
                        [
                            {
                                values: PRODUCT_LIST.gridHorizontalGap.map(x => (x ? `calc((-${x} / 2) - 1px)` : null)),
                                properties: ["left"],
                            },
                        ],
                        mediaOptions.min,
                    )}
            }
        `,
    },
});
